import { render, staticRenderFns } from "./WarningEnvironment.vue?vue&type=template&id=80fb3c46&"
import script from "./WarningEnvironment.vue?vue&type=script&lang=js&"
export * from "./WarningEnvironment.vue?vue&type=script&lang=js&"
import style0 from "./WarningEnvironment.vue?vue&type=style&index=0&id=80fb3c46&prod&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports